export default "__VITE_ASSET__SMMGQjv0__"